import { useDispatch } from 'react-redux';

const useDispatchFactory = fn => {
  const dispatch = useDispatch();
  return payload => dispatch(fn(payload));
};

export default useDispatchFactory;
